import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import ClientPortal from "@/pages/ClientPortal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Public = ({ children, overlayHeader = false }) => <PublicLayout overlayHeader={overlayHeader}>{children}</PublicLayout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Public overlayHeader><Home /></Public>} />
            <Route path="/projects" element={<Public><Projects /></Public>} />
            <Route path="/projects/:id" element={<Public><ProjectDetail /></Public>} />
            <Route path="/services" element={<Public><Services /></Public>} />
            <Route path="/gallery" element={<Public><Gallery /></Public>} />
            <Route path="/contact" element={<Public><Contact /></Public>} />
            <Route path="/portal/:token" element={<ClientPortal />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
